// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root___adN6","head":"Table_head__1SawB","col":"Table_col__2fL3s"};